import { semantic, typography } from '@/shared/theme/tokens';

/**
 * ErrorState — shown when a data query fails. Mirrors the inline ErrorState
 * previously duplicated across list pages.
 *
 * Props:
 *   message — error text (falls back to a generic message)
 */
export function ErrorState({ message }) {
  return (
    <div style={{ padding: '40px', textAlign: 'center', color: semantic.error }}>
      <span className="material-symbols-outlined" style={{ fontSize: 32, display: 'block', marginBottom: '8px' }}>error</span>
      <p style={{ fontSize: typography.fontSize.lg, margin: 0 }}>{message ?? 'Failed to load. Please try again.'}</p>
    </div>
  );
}
